export default "__VITE_ASSET__Chof5aih__"